import {
  DirectPublishingModalController,
  DirectPublishingModalControllerProps
} from './DirectPublishingModal.controller';
import React from 'react';
import {
  Network,
  SocialOAuthContext,
  SocialOAuthProvider,
  useStartSocialOAuthMutation
} from '../../../../models/graphql';

export type DirectPublishingModalApolloProps = Omit<DirectPublishingModalControllerProps, 'startSocialOAuth'> & {
  //
};

export const DirectPublishingModalApollo = (props: DirectPublishingModalApolloProps): JSX.Element => {
  const [startSocialOAuth] = useStartSocialOAuthMutation({
    fetchPolicy: 'no-cache',
    variables: {
      oAuthProvider: SocialOAuthProvider.FACEBOOK,
      profileNetwork: Network.FACEBOOK,
      context: SocialOAuthContext.RECONNECT
    }
  });

  const args: DirectPublishingModalControllerProps = {
    ...props,
    startSocialOAuth
  };

  return <DirectPublishingModalController {...args} />;
};
